import { render, staticRenderFns } from "./AlarmDetails.vue?vue&type=template&id=22d0fb8d&scoped=true&"
import script from "./AlarmDetails.vue?vue&type=script&lang=js&"
export * from "./AlarmDetails.vue?vue&type=script&lang=js&"
import style0 from "./AlarmDetails.vue?vue&type=style&index=0&id=22d0fb8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0fb8d",
  null
  
)

export default component.exports